import { render } from "./basket_component.vue?vue&type=template&id=320b3860&scoped=true"
import script from "./basket_component.vue?vue&type=script&lang=js"
export * from "./basket_component.vue?vue&type=script&lang=js"

import "./basket_component.vue?vue&type=style&index=0&id=320b3860&scoped=true&lang=css"

import exportComponent from "/home/raphael/git/proclima/retailerportal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320b3860"]])

export default __exports__